/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Header_Explore_Legends_LabelInputs */

const en_common_header_explore_legends_label = /** @type {(inputs: Common_Header_Explore_Legends_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launch Legends`)
};

const zh_common_header_explore_legends_label = /** @type {(inputs: Common_Header_Explore_Legends_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发布传奇`)
};

/**
* | output |
* | --- |
* | "Launch Legends" |
*
* @param {Common_Header_Explore_Legends_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_header_explore_legends_label = /** @type {((inputs?: Common_Header_Explore_Legends_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Header_Explore_Legends_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_header_explore_legends_label(inputs)
	return zh_common_header_explore_legends_label(inputs)
});
export { common_header_explore_legends_label as "common.header.explore.legends.label" }